const env = process.env.REACT_APP_ENV || 'development';

const config = {
  env,
  // Siempre prioriza REACT_APP_API_BASE_URL si está definida
  apiBaseUrl:
    process.env.REACT_APP_API_BASE_URL ||
    (env === 'development' ? 'http://192.168.0.112:8000/version1' : 'http://192.168.0.112:8000/version1'),
  apiKey: process.env.REACT_APP_API_KEY || process.env.API_KEY || '',
};

export default config;

// Log ofuscado: muestra solo los primeros caracteres para identificar el endpoint sin exponerlo completo
try {
  const raw = String(config.apiBaseUrl || '');
  const firstPart = raw.slice(0, 18);
  const lengthInfo = raw.length;
  const randomSuffix = Math.random().toString(36).slice(2, 8);
  const code = `${firstPart}-${randomSuffix}`;
  console.log('signature:', `len=${lengthInfo}, head=${firstPart}, code=${code}`);
} catch (_) {
  // evitar romper la app por un error en logging
}
